import BaseWidget from "common/widgets/PromptList/ReadOnlyPromptInput";

const ReadOnlyPromptInput = BaseWidget.extend({

    init: function(element, options) {
        BaseWidget.fn.init.apply(this, arguments);

        this.measure = $("<span>", {
            style: "display:none;",
            "class": "measurement"
        });
        this.element.append(this.measure);

        this._updateStyle();

    },

    getMinSize: function() {
        var minSize = BaseWidget.fn.getMinSize.apply(this, arguments);
        minSize.width = 20;
        return minSize;
    },

    updateStyle: function() {
        BaseWidget.fn.updateStyle.apply(this, arguments);
        this._updateStyle();
        this._updateStyleType();
    },

    _updateStyle: function() {
        this.setElementStyle(this.element);
    }
});

kendo.ui.plugin(ReadOnlyPromptInput);
export default ReadOnlyPromptInput;
